 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"01b208ddd0db20001da5ef1dd8ffabaad47bef90","3":"aab635a4d9e0cbfeaec1789c46d41192d593844f","4":"f6d09afbdddd7073050d65fb249b23c0102b45f1","5":"afb16dd5219597e95ec25bf1877403ba8d33bf1e","9":"29107295","12":"component---src-pages-404-tsx","13":"component---src-pages-abonnieren-tsx","14":"component---src-pages-agb-tsx","15":"component---src-pages-anmelden-tsx","16":"component---src-pages-autoren-tsx","17":"component---src-pages-autorenvereinbarung-tsx","18":"component---src-pages-codes-tsx","19":"component---src-pages-datenschutz-tsx","20":"component---src-pages-edition-makroskop-tsx","21":"component---src-pages-freiexemplar-tsx","22":"component---src-pages-gespraechskreise-tsx","23":"component---src-pages-guide-tsx","24":"component---src-pages-impressum-tsx","25":"component---src-pages-jobs-tsx","26":"component---src-pages-kontakt-tsx","27":"component---src-pages-leserbriefe-tsx","28":"component---src-pages-lesezeichen-tsx","29":"component---src-pages-makronaut-tsx","30":"component---src-pages-newsletter-tsx","31":"component---src-pages-passwort-vergessen-tsx","32":"component---src-pages-registrieren-tsx","33":"component---src-pages-themenhefte-tsx","34":"component---src-pages-ueber-uns-tsx","35":"component---src-pages-webshop-tsx","36":"component---src-pages-weihnachten-tsx","37":"component---src-templates-all-articles-tsx","38":"component---src-templates-all-editions-tsx","39":"component---src-templates-all-spotlights-tsx","40":"component---src-templates-article-tsx","41":"component---src-templates-event-tsx","42":"component---src-templates-home-page-tsx","43":"component---src-templates-magazine-tsx","44":"component---src-templates-podcasts-tsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"2538985de6f2e4777e5a","2":"84076cd26a2d2ed66fe4","3":"d9587efaf77b58a47484","4":"d601525e7276d2b4c59c","5":"92f36f227d96da8616c4","7":"de7d3a08afef73d0b42c","9":"cc058dc6ea8a785db1ae","12":"3668fb3b8abb5b76801e","13":"36b119c4e27eed5cc41d","14":"bc17aa96871d1011f528","15":"9af85be5a3ee171b5372","16":"48e35cc3103b1a373a29","17":"c50ceaddad9b8e2f4f55","18":"ef13904de721f5ac190b","19":"977b74adb872f9de3940","20":"b0464561f2a4af613528","21":"6123ca01b5711851dadc","22":"bffcc4ed1aa82be757a0","23":"10505f5cf8223fae639b","24":"6455e884068213092f66","25":"ae16311306c5826c6ef9","26":"d8265b0b48fb2745bc4a","27":"0502e431cfe3a9da0454","28":"180b1486108882fcbf22","29":"5aa92f9c53de54a91f58","30":"ba29126982314c198ebd","31":"29a9caf66c8d147ffd46","32":"adf26ecbb0f7e6ef600f","33":"75b88f9d287b9cc9856c","34":"a40d318e7f583dd23bcd","35":"1736839b534a237433f1","36":"efcddb74c3025077ce5a","37":"452f8dc05211839afb06","38":"2654b15b2288964e7f93","39":"febf0344e72e1f9dbd28","40":"b9dc39e71798057f9733","41":"315abfd5ad1e39c587a2","42":"e3f8af022e220d210eb3","43":"ccdd3cb5c1f8fd1f5104","44":"77c38e233ea24171224e","47":"5d48dd0bd7750dcb4bb1","48":"e232d6bb9852e1bc5f91"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"01b208ddd0db20001da5ef1dd8ffabaad47bef90","3":"aab635a4d9e0cbfeaec1789c46d41192d593844f","4":"f6d09afbdddd7073050d65fb249b23c0102b45f1","5":"afb16dd5219597e95ec25bf1877403ba8d33bf1e","9":"29107295","12":"component---src-pages-404-tsx","13":"component---src-pages-abonnieren-tsx","14":"component---src-pages-agb-tsx","15":"component---src-pages-anmelden-tsx","16":"component---src-pages-autoren-tsx","17":"component---src-pages-autorenvereinbarung-tsx","18":"component---src-pages-codes-tsx","19":"component---src-pages-datenschutz-tsx","20":"component---src-pages-edition-makroskop-tsx","21":"component---src-pages-freiexemplar-tsx","22":"component---src-pages-gespraechskreise-tsx","23":"component---src-pages-guide-tsx","24":"component---src-pages-impressum-tsx","25":"component---src-pages-jobs-tsx","26":"component---src-pages-kontakt-tsx","27":"component---src-pages-leserbriefe-tsx","28":"component---src-pages-lesezeichen-tsx","29":"component---src-pages-makronaut-tsx","30":"component---src-pages-newsletter-tsx","31":"component---src-pages-passwort-vergessen-tsx","32":"component---src-pages-registrieren-tsx","33":"component---src-pages-themenhefte-tsx","34":"component---src-pages-ueber-uns-tsx","35":"component---src-pages-webshop-tsx","36":"component---src-pages-weihnachten-tsx","37":"component---src-templates-all-articles-tsx","38":"component---src-templates-all-editions-tsx","39":"component---src-templates-all-spotlights-tsx","40":"component---src-templates-article-tsx","41":"component---src-templates-event-tsx","42":"component---src-templates-home-page-tsx","43":"component---src-templates-magazine-tsx","44":"component---src-templates-podcasts-tsx"}[chunkId]||chunkId) + "." + {"0":"c34c56df8fd297f96749","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
